import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

function BookingConfirmation(props) {
  const [reason, setReason] = useState('');

  const handleSave = () => {
    props.onSave(reason); // Pass reason back to parent
  };

  const handleClose = () => {
    setReason(''); // Clear reason on close
    props.handleClose();
  };

  return (
    <Modal show={props.show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to perform this action?</p>
        <textarea
          className="form-control px-3"
          placeholder="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default BookingConfirmation;
